import Link from 'next/link';
import {useRouter} from 'next/router';
import {memo} from 'react';
import useWindowWidth from '../../../hooks/useWindowWidth';
import storiesCategoryItems from './storiesCategoryItems';
import styles from '../../../styles/components/section/stories/Categories.module.scss';

const Categories = memo(({spNone, postCategory, stories}) => {
    const {breakPoint, windowWidth} = useWindowWidth();
    const router = useRouter();
    const onChangeCategorySp = (e) => {
        router.push(e.target.value);
    };

    return (
        <div
            className={`${styles.container} ${
                spNone && windowWidth <= breakPoint
                    ? ''
                    : styles.containerSpNone
            }`}
        >
            <div className={styles.wrapper}>
                <div className={styles.head}>
                    <h1 className={styles.headTitle}>STORIES</h1>
                </div>
                <div className={styles.body}>
                    <div className={styles.bodyCategories}>
                        {/* width > 768 */}

                        <ul
                            className={`${styles.bodyCategoriesList} ${
                                windowWidth > breakPoint ? '' : 'u-none__sp'
                            }`}
                        >
                            {storiesCategoryItems.map((data) => {
                                if (typeof stories !== "undefined") {
                                    let important = stories.filter(story => {
                                        return story.fields.category === data.text
                                    })
                                    if (important.length === 0)
                                    {
                                        if (data.text === '重要なお知らせ') return
                                    }
                                }
                                return (
                                    <li
                                        className={`${
                                            styles.bodyCategoriesItem
                                        } ${
                                            data.href.includes(
                                                router.query.category ||
                                                postCategory
                                                // ||'すべての記事'
                                            )
                                                ? 'is-current'
                                                : ''
                                        }`}
                                        key={data.key}
                                    >
                                        <Link href={data.href}>
                                            <a
                                                className={`${styles.bodyCategoriesLink} eatBodyCategoriesLink js-hover js-hover__color__point`}
                                                data-hover-in-time="600"
                                                data-hover-out-time="0"
                                            >
                                                {data.text}
                                            </a>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                        {/* {width <= 768 && spNone && */}
                        {windowWidth <= breakPoint && spNone && (
                            <>
                                <select
                                    className={`${styles.bodyCategoriesSelect} u-none__pc`}
                                    onChange={(e) => onChangeCategorySp(e)}
                                >
                                    {storiesCategoryItems.map((data) => {
                                        return (
                                            <option
                                                value={data.href}
                                                key={data.key}
                                                selected={data.href.includes(
                                                    router.query.category
                                                )}
                                            >
                                                {data.text}
                                            </option>
                                        );
                                    })}
                                </select>
                                <svg
                                    className={styles.bodyCategoriesSelectSvg}
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6 0.999115L6 11.0009"
                                        stroke="#0C3B2C"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M1 5.99997L5.99918 11L11 5.99997"
                                        stroke="#0C3B2C"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});

Categories.displayName = 'Categories';

export default Categories;
